import * as React from 'react';
import { Button } from '@/components/ui/button';
import { UserMenu } from './UserMenu';
import { WorkspaceSwitcher } from './WorkspaceSwitcher';
import { ThemeToggle } from '@/components/theme';
import { Bell, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface HeaderProps {
  sidebarCollapsed: boolean;
}

export function Header({ sidebarCollapsed }: HeaderProps): React.JSX.Element {
  return (
    <header
      role="banner"
      aria-label="Main header"
      className={cn(
        'fixed top-0 right-0 z-30 flex h-16 items-center border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 transition-all duration-300',
        sidebarCollapsed ? 'left-16' : 'left-64'
      )}
    >
      <div className="flex w-full items-center justify-between px-6">
        {/* Left section */}
        <div className="flex items-center gap-4">
          <WorkspaceSwitcher />
        </div>

        {/* Center - Search */}
        <div className="hidden md:flex flex-1 max-w-md mx-4" role="search">
          <div className="relative w-full">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" />
            <Input
              type="search"
              placeholder="Search repositories, PRDs..."
              aria-label="Search repositories and PRDs"
              className="w-full pl-9"
            />
          </div>
        </div>

        {/* Right section */}
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            disabled
            aria-label="Notifications (coming soon)"
          >
            <Bell className="h-5 w-5" aria-hidden="true" />
            {/* TODO: Wire up real notification system */}
          </Button>
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
